"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  justify-self: ", ";\n  align-self: ", ";\n  place-self: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    grid-area: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridItemColumn = exports.gridItemRow = exports.gridItemArea = exports.gridItem = void 0;

var _stylitas = require("@creditas/stylitas");

var gridItemArea = function gridItemArea(_ref) {
  var area = _ref.area;
  return area && (0, _stylitas.css)(_templateObject(), area);
};

exports.gridItemArea = gridItemArea;

var gridItemRow = function gridItemRow(_ref2) {
  var gridRow = _ref2.gridRow;
  return gridRow && (0, _stylitas.css)(_templateObject2(), (0, _stylitas.mq)({
    gridRow: (0, _stylitas.mediaValue)(gridRow.xs, gridRow.md)
  }));
};

exports.gridItemRow = gridItemRow;

var gridItemColumn = function gridItemColumn(_ref3) {
  var gridColumn = _ref3.gridColumn;
  return gridColumn && (0, _stylitas.css)(_templateObject3(), (0, _stylitas.mq)({
    gridColumn: (0, _stylitas.mediaValue)(gridColumn.xs, gridColumn.md)
  }));
};

exports.gridItemColumn = gridItemColumn;

var gridItem = function gridItem(_ref4) {
  var justifySelf = _ref4.justifySelf,
      alignSelf = _ref4.alignSelf,
      placeSelf = _ref4.placeSelf;
  return (0, _stylitas.css)(_templateObject4(), justifySelf, alignSelf, placeSelf);
};

exports.gridItem = gridItem;